// Single source of truth for Loadout categories (PROMPT 3.0 §0).
// Both the Armory tiles and the Build-my-Loadout quiz filter store import
// from here — the two surfaces cannot drift. Categories are keyed by
// Shopify product_type, NOT Collection handles.

export const CATEGORIES = [
        {
                id: 'keyboards',
                product_type: 'Keyboard',
                title: 'KEYBOARDS',
                subline: 'Mechanical · Hall Effect · Optical',
        },
        {
                id: 'mice',
                product_type: 'Mouse',
                title: 'MICE',
                subline: 'Pixart 3395 · 3950 · 3955 · 36g to 65g',
        },
        {
                id: 'mousepads',
                product_type: 'Mousepad',
                title: 'MOUSEPADS',
                subline: 'Speed · Control · Balanced',
        },
        {
                id: 'keycaps',
                product_type: 'Keycap',
                title: 'KEYCAPS',
                subline: 'PBT · ABS · Sculpted · Flat',
        },
];

export function listCategories() {
        return CATEGORIES.slice();
}

export function getCategoryById(id) {
        return CATEGORIES.find((c) => c.id === id) || null;
}

export function productTypeForId(id) {
        const c = getCategoryById(id);
        return c ? c.product_type : null;
}
